import { render } from "./LinkArrow.vue?vue&type=template&id=0b7c6565&scoped=true"
import script from "./LinkArrow.vue?vue&type=script&lang=js"
export * from "./LinkArrow.vue?vue&type=script&lang=js"

import "./LinkArrow.vue?vue&type=style&index=0&id=0b7c6565&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7c6565"]])

export default __exports__